import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../constants/Languages.js';

import arrow from '../assets/icons/arrow-circle-empty-light.svg';

const WelcomeBar = ({ clang, closeWelcomeBar }) => {
    return (
        <div className="welcome-bar">
            <div className="welcome-bar__content">
                <p className="welcome-bar__desc" dangerouslySetInnerHTML={{__html: lang[clang].welcome_desc}}></p>
                <button className="welcome-bar__button" onClick={() => closeWelcomeBar()}>
                    {lang[clang].welcome_go}
                    <img src={arrow} alt="" className="welcome-bar__button-img"/>
                </button>
            </div>
        </div>
    );
};

WelcomeBar.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(WelcomeBar);



// WEBPACK FOOTER //
// ./src/components/WelcomeBar.js